<!-- Include Font Awesome for icons -->
<link
  rel="stylesheet"
  href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css"
/>
<div class="tab-content" appBlur>
  <div class="page-title">
    <h4 translate>DEVIATIONS</h4>
  </div>
  <!-- Charts section -->
  <div class="chart">
    <div class="button-container d-flex justify-content-end">
      <button
        class="btn nav-button"
        [ngClass]="{
          'btn-outline-red': !isPaused,
          'btn-outline-green': isPaused
        }"
        (click)="togglePause()"
      >
        <i
          class="fas"
          [ngClass]="{
            'fa-pause': !isPaused,
            'fa-play': isPaused,
            'pause-icon': !isPaused,
            'play-icon': isPaused
          }"
        ></i>
      </button>
      <button
        class="btn btn-outline-primary nav-button"
        (click)="changeChart('previous')"
      >
        <i class="fas fa-chevron-left"></i>
      </button>
      <button
        class="btn btn-outline-primary nav-button"
        (click)="changeChart('next')"
      >
        <i class="fas fa-chevron-right"></i>
      </button>
    </div>

    <app-deviation-list-charts
      [chartView]="chartView"
      [deviationMetadata]="deviationListMetadata"
      [deviationListCount]="totalRecords"
      [isPortal]="isPortal"
      (buttonClicked)="onChildButtonClicked()"
    ></app-deviation-list-charts>
  </div>
  <!-- Charts section ends -->
  <div class="page-actions">
    <div class="selected-actions" *ngIf="isPortal">
      <div class="multi-action-buttons">
        <button
          class="btn btn-delete"
          (click)="confirmMultiDelete()"
          [disabled]="!canDeleteSelected"
          [pTooltip]="
            selectedDeviations.length === 0
              ? ('SELECT_DEVIATIONS_TO_DELETE' | translate)
              : ''
          "
          tooltipPosition="top"
        >
          <i class="pi pi-trash"></i>
          {{ "DELETE" | translate }}
        </button>
      </div>
      <div class="selected-counter">
        <span class="counter-text">
          {{ allSelectedDeviations.size }} / {{ totalRecords }}
          {{ "SELECTED" | translate }}
        </span>
        <button
          class="btn btn-outline-primary btn-medium"
          (click)="clearSelection()"
          *ngIf="allSelectedDeviations.size > 0"
        >
          <i class="pi pi-refresh"></i>
        </button>
      </div>
    </div>

    <!-- New button -->
    <div class="deviation-create-actions" *ngIf="isShowNewButton">
      <button
        (click)="onManageQrCodeClick()"
        class="btn btn-warning"
        *ngIf="isQrCode && isEditor"
      >
        <span class="fa fa-qrcode"></span>
        <span translate>MANAGE_QR_CODE</span>
      </button>
      <button (click)="onNewButtonClick()" class="btn btn-success">
        <i class="pi pi-plus"></i>
        <span translate>NEW</span>
      </button>
    </div>
  </div>
  <div class="table-view">
    <!-- Table starts -->
    <p-table
      #deviationTable
      [value]="deviationList"
      [rows]="paginationRequest.pageSize"
      [totalRecords]="totalRecords"
      [paginator]="true"
      [lazy]="true"
      [pageLinks]="5"
      [rowsPerPageOptions]="[10, 25, 50]"
      [loading]="isLoadingData"
      [showCurrentPageReport]="true"
      [sortMode]="'single'"
      [sortField]="paginationRequest.sortColumn"
      [sortOrder]="paginationRequest.sortDirection === 'DESC' ? -1 : 1"
      (onFilter)="deviationFilterChange($event)"
      (onSort)="onSort($event)"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} records"
      (onPage)="deviationPageChange($event)"
      [alwaysShowPaginator]="true"
      styleClass="seamless-table kuba-deviation-table"
    >
      <!-- Caption -->
      <ng-template pTemplate="caption">
        <div class="ui-helper-clearfix">
          <div
            class="filter-controls-wrapper"
            [style.display]="showFilters ? 'block' : 'none'"
          >
            <div class="row">
              <div class="col-md-4" *ngIf="!isAdmin && !isPortal">
                <div class="form-group">
                  <label class="col-form-label">
                    <span translate>SHOW_DEVIATION</span>
                  </label>
                  <div class="input-group">
                    <p-select
                      [options]="ShowDeviation"
                      [style]="{ width: '100%' }"
                      (onChange)="onShowDeviationChanged($event)"
                      #showDeviation
                      [disabled]="showDeviationDisabled"
                    ></p-select>
                  </div>
                </div>
              </div>
              <div class="col-md-4" *ngIf="!isAdmin && !isPortal">
                <div class="form-group">
                  <label class="col-form-label">
                    <span translate>RESPONSIBLE_FOR_FOLLOWUP</span>
                  </label>
                  <div>
                    <p-autoComplete
                      [(ngModel)]="selectedFollowUpPerson"
                      [suggestions]="filteredFollowUpPersons"
                      (completeMethod)="filterFollowUpPersons($event)"
                      (onSelect)="onFollowupSelected($event.value)"
                      (onClear)="onFollowupCleared()"
                      optionLabel="label"
                      [dropdown]="true"
                      [showClear]="true"
                      [style]="{ width: '100%' }"
                      placeholder="Search responsible person..."
                      emptyMessage="No persons found"
                      [minLength]="0"
                    >
                      <ng-template let-person pTemplate="item">
                        <div class="autocomplete-item">
                          {{ person.label }}
                        </div>
                      </ng-template>
                    </p-autoComplete>
                  </div>
                </div>
              </div>
              <div class="col-md-4" [formGroup]="deviationSearch">
                <div class="form-group">
                  <label class="col-form-label">
                    <span translate>TYPE_OF_CASE</span>
                  </label>
                  <div class="input-btn-group">
                    <p-select
                      [options]="Case"
                      [style]="{ width: '150px' }"
                      formControlName="typeOfCase"
                      [filter]="true"
                      [filterBy]="'label'"
                      (onChange)="onCaseChanged(caseDropdown)"
                      #caseDropdown
                    ></p-select>
                    <button
                      type="button"
                      class="btn btn-outline-primary"
                      *ngIf="isShowPlusbutton"
                      (click)="addtypeOfCase = !addtypeOfCase"
                    >
                      <i class="pi pi-plus" aria-hidden="true"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <div class="form-group">
                  <label for="startDate" class="col-form-label">
                    <span translate>CREATED_FROM</span>
                  </label>
                  <div>
                    <p-datepicker
                      [(ngModel)]="craetedFromFilter"
                      dateFormat="dd/mm/yy"
                      [showIcon]="true"
                      [showButtonBar]="true"
                      placeholder="{{ 'SELECT_START_DATE' | translate }}"
                      (onSelect)="onStartDateChanged(craetedFromFilter)"
                      (onClear)="onStartDateChanged(null)"
                      required
                    ></p-datepicker>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label for="endDate" class="col-form-label">
                    <span translate>CREATED_TO</span>
                  </label>
                  <div>
                    <p-datepicker
                      [(ngModel)]="createdToFilter"
                      dateFormat="dd/mm/yy"
                      [showIcon]="true"
                      [showButtonBar]="true"
                      placeholder="{{ 'SELECT_END_DATE' | translate }}"
                      (onSelect)="onEndDateChanged(createdToFilter)"
                      (onClear)="onEndDateChanged(null)"
                      required
                    ></p-datepicker>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4" *ngIf="!isAdmin">
                <form [formGroup]="deviationSearch">
                  <div class="form-group">
                    <label class="col-form-label">
                      <span translate>TOPICS</span>
                    </label>
                    <div>
                      <p-select
                        [options]="Topics"
                        [style]="{ width: '150px' }"
                        formControlName="topic"
                        (onChange)="onTopicChanged(topicDropdown)"
                        #topicDropdown
                        filter="filter"
                      ></p-select>
                      <button
                        type="button"
                        class="btn btn-outline-primary"
                        *ngIf="isShowPlusbutton"
                        (click)="addTopic = !addTopic"
                      >
                        <i class="pi pi-plus" aria-hidden="true"></i>
                      </button>
                    </div>
                  </div>
                </form>
              </div>
              <div class="col-md-4" *ngIf="!isAdmin && !isPortal && isKunde">
                <div class="form-group">
                  <label class="col-form-label">
                    <span translate>CLIENT</span>
                  </label>
                  <div>
                    <p-select
                      [options]="Client"
                      [(ngModel)]="clientFilter"
                      (onChange)="onClientChanged(clientDropdown)"
                      #clientDropdown
                      [filter]="true"
                      [style]="{ width: '100%' }"
                    ></p-select>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <div class="form-group" *ngIf="!isAdmin && !isPortal">
                  <label class="col-form-label">
                    <span translate>RESPONSIBLE_FOR_EXECUTION</span>
                  </label>
                  <div>
                    <p-autoComplete
                      [(ngModel)]="selectedExecutionPerson"
                      [suggestions]="filteredExecutionPersons"
                      (completeMethod)="filterExecutionPersons($event)"
                      (onSelect)="onExecutionSelected($event.value)"
                      (onClear)="onExecutionCleared()"
                      optionLabel="label"
                      [dropdown]="true"
                      [showClear]="true"
                      [style]="{ width: '100%' }"
                      placeholder="Search responsible person..."
                      emptyMessage="No persons found"
                      [minLength]="0"
                    >
                      <ng-template let-person pTemplate="item">
                        <div class="autocomplete-item">
                          {{ person.label }}
                        </div>
                      </ng-template>
                    </p-autoComplete>
                  </div>
                </div>
              </div>

              <div class="col-md-2" *ngIf="isDeptSelected">
                <div class="form-group">
                  <label class="col-form-label">
                    <span translate>SUB_DEPARTMENT</span>
                  </label>
                  <div class="input-group">
                    <p-select
                      [options]="subDepartments"
                      [style]="{ width: '100%' }"
                      (onChange)="onSubDepartmentChanged(subDepControl)"
                      #subDepControl
                      [filter]="true"
                    ></p-select>
                  </div>
                </div>
              </div>
              <div class="col-md-4" *ngIf="isBusinessId">
                <div class="form-group">
                  <label for="endDate" class="col-form-label">
                    <span translate>CREATED_BY</span>
                  </label>
                  <div>
                    <p-select
                      [options]="createdBy"
                      [(ngModel)]="createdByFilter"
                      [style]="{ width: '100%' }"
                      (onChange)="onCreatedByChange($event, createdByDropdown)"
                      #createdByDropdown
                    ></p-select>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label class="col-form-label">
                    <span translate>COST</span>
                  </label>
                  <div class="cost-column-toggle">
                    <p-checkbox
                      [(ngModel)]="showCostColumn"
                      [binary]="true"
                      inputId="showCostColumn"
                      (onChange)="onShowCostColumnChange()"
                    ></p-checkbox>
                    <label for="showCostColumn" translate>COST</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="table-options">
            <div class="pull-right">
              <span
                class="current-sort-info ml-2"
                *ngIf="getActiveFiltersCount() > 0"
              >
                <i class="fas fa-filter"></i>
                <span translate>ACTIVE_FILTERS</span>:
                {{ getActiveFiltersCount() }}
              </span>
              <button
                class="reset-filter-btn"
                type="submit"
                (click)="clearFilters()"
                *ngIf="getActiveFiltersCount() > 0"
              >
                <span class="icon ic-sm icon-reset"></span>
                <span translate>RESET_FILTERS</span>
              </button>
              <button
                class="clear-sort-btn"
                type="button"
                (click)="clearSorting()"
                [disabled]="!paginationRequest.sortColumn"
                title="Clear current sorting"
              >
                <i class="pi pi-sort me-2"></i>
                <span translate>CLEAR_SORT</span>
              </button>

              <button class="btn p-3" (click)="toggleFilters()">
                <span class="icon ic-sm icon-filter"></span>
                <span translate>FILTER</span>
              </button>

              <div class="action-btns-group">
                <kuba-export
                  [printMode]="1"
                  [reportData]="
                    deviationTable.filteredValue || deviationTable.value
                  "
                  [filters]="deviationFilterDto"
                  [applicationId]="applicationId"
                  [isPortal]="isPortal"
                  [portalId]="portalId"
                  [exportAllData]="true"
                  (loading)="loader($event)"
                  [additionalData]="additionalData"
                ></kuba-export>
              </div>
            </div>
          </div>
        </div>
      </ng-template>

      <!-- Header with sortable columns -->
      <ng-template pTemplate="header">
        <tr>
          <th class="deviation-column-select" *ngIf="isPortal">
            <p-checkbox
              [(ngModel)]="isAllSelected"
              [binary]="true"
              (onChange)="onSelectAllChange($event)"
            >
            </p-checkbox>
          </th>
          <th
            class="deviation-column-number"
            pSortableColumn="No"
            *ngIf="!isPortal"
          >
            {{ "NUMBER_NO" | translate }}
            <p-sortIcon field="No"></p-sortIcon>
          </th>
          <th
            class="deviation-column-number"
            pSortableColumn="No"
            *ngIf="isPortal"
          >
            {{ "NUMBER_NO" | translate }}
            <p-sortIcon field="No"></p-sortIcon>
          </th>
          <th
            class="deviation-column-business"
            pSortableColumn="BusinessName"
            *ngIf="isAdmin || isPortal"
          >
            {{ "BUSINESS" | translate }}
            <p-sortIcon field="BusinessName"></p-sortIcon>
          </th>
          <th class="deviation-column-title" pSortableColumn="Title">
            {{ "TITLE" | translate }}
            <p-sortIcon field="Title"></p-sortIcon>
          </th>
          <th class="deviation-column-checklist" *ngIf="userRole == 'Editor'">
            {{ "CHECKLIST_NAME" | translate }}
          </th>
          <th class="deviation-column-activity" *ngIf="!isAdmin">
            {{ "ACITVITY" | translate }}
          </th>
          <th class="deviation-column-status">{{ "STATUS" | translate }}</th>
          <th class="deviation-column-importance">
            {{ "IMPORTANCE" | translate }}
          </th>
          <th class="deviation-column-department">
            {{ "DEPARTMENT" | translate }}
          </th>
          <th class="deviation-column-date">
            {{ "DEADLINE" | translate }}
          </th>
          <th class="deviation-column-module">
            {{ "MODULES" | translate }}
          </th>
          <th class="deviation-column-cost" *ngIf="showCostColumn">
            {{ "COST" | translate }}
          </th>
          <th class="deviation-column-date" pSortableColumn="CompletedDate">
            {{ "DONE_ON" | translate }}
            <p-sortIcon field="CompletedDate"></p-sortIcon>
          </th>
          <th class="deviation-column-date" pSortableColumn="CreatedOn">
            {{ "CREATED_ON" | translate }}
            <p-sortIcon field="CreatedOn"></p-sortIcon>
          </th>
          <th
            class="deviation-column-actions"
            *ngIf="hasDeviationDeleteAccess && !isPortal"
          ></th>
        </tr>
        <tr>
          <th *ngIf="isPortal"></th>
          <th [attr.data-label]="'NUMBER_NO' | translate">
            <input
              pInputText
              type="text"
              [(ngModel)]="noFilter"
              (input)="onTextFilterChange('no', $any($event.target)?.value)"
              placeholder=""
              class="p-column-filter"
            />
          </th>
          <th [attr.data-label]="'BUSINESS' | translate" *ngIf="isAdmin || isPortal">
            <input
              pInputText
              type="text"
              [(ngModel)]="businessNameFilter"
              (input)="
                onTextFilterChange('businessName', $any($event.target)?.value)
              "
              placeholder=""
              class="p-column-filter"
            />
          </th>
          <th [attr.data-label]="'TITLE' | translate">
            <input
              pInputText
              type="text"
              [(ngModel)]="titleFilter"
              (input)="onTextFilterChange('title', $any($event.target)?.value)"
              placeholder=""
              class="p-column-filter"
            />
          </th>
          <th [attr.data-label]="'CHECKLIST_NAME' | translate" *ngIf="userRole == 'Editor'">
            <input
              pInputText
              type="text"
              [(ngModel)]="checklistNameFilter"
              (input)="
                onTextFilterChange('checklistName', $any($event.target)?.value)
              "
              placeholder=""
              class="p-column-filter"
            />
          </th>
          <th [attr.data-label]="'ACITVITY' | translate" *ngIf="!isAdmin">
            <input
              pInputText
              type="text"
              [(ngModel)]="activityNameFilter"
              (input)="
                onTextFilterChange('activityName', $any($event.target)?.value)
              "
              placeholder=""
              class="p-column-filter"
            />
          </th>

          <th [attr.data-label]="'STATUS' | translate">
            <p-select
              [options]="statuses"
              [style]="{ width: '100%' }"
              (onChange)="onStatusChanged($event)"
              (onClear)="onStatusCleared()"
              #statusDropdown
              styleClass="p-column-filter"
              placeholder="Select Status"
              [showClear]="true"
              appendTo="body"
              [filter]="false"
              [virtualScroll]="false"
            >
              <ng-template let-status pTemplate="item">
                <span>{{ status.label | translate }}</span>
              </ng-template>
              <ng-template let-status pTemplate="selectedItem">
                <span>{{ status.label | translate }}</span>
              </ng-template>
            </p-select>
          </th>
          <th [attr.data-label]="'IMPORTANCE' | translate">
            <p-select
              [options]="importances"
              #impControl
              (onChange)="onImportanceChange($event, impControl)"
              styleClass="p-column-filter"
              placeholder=""
              [filterBy]="null"
              [showClear]="true"
              appendTo="body"
            >
              <ng-template let-status pTemplate="item">
                {{ status.label | translate }}
              </ng-template>
            </p-select>
          </th>
          <th [attr.data-label]="'DEPARTMENT' | translate">
            <!-- Admin and Portal: text input filter -->
            <input
              *ngIf="isAdmin || isPortal"
              pInputText
              type="text"
              [(ngModel)]="departmentFilter"
              (input)="
                onTextFilterChange('department', $any($event.target)?.value)
              "
              placeholder=""
              class="p-column-filter"
            />
            <!-- Business: dropdown filter -->
            <p-select
              *ngIf="!isAdmin && !isPortal"
              [options]="departments"
              #depControl
              (onChange)="onDepartmentChangedName(depControl)"
              placeholder=""
              [filterBy]="null"
              [showClear]="true"
              appendTo="body"
            >
              <ng-template let-status pTemplate="item">
                {{ status.label | translate }}
              </ng-template>
            </p-select>
          </th>
          <th></th>
          <th [attr.data-label]="'MODULES' | translate">
            <p-select
              [options]="vModules"
              #modules
              (onChange)="onModuleChange($event)"
              styleClass="p-column-filter"
              placeholder=""
              [filter]="true"
              [filterBy]="'label'"
              [showClear]="true"
              appendTo="body"
            >
              <ng-template let-module pTemplate="item">
                {{ module.label }}
              </ng-template>
            </p-select>
          </th>
          <th *ngIf="showCostColumn"></th>
          <th></th>
          <th></th>
          <th *ngIf="hasDeviationDeleteAccess && !isPortal"></th>
        </tr>
      </ng-template>

      <!-- Body Content -->
      <ng-template pTemplate="body" let-deviation let-i="rowIndex">
        <tr>
          <td
            class="checkbox-column deviation-cell-select"
            style="text-align: center"
            *ngIf="isPortal"
          >
            <p-checkbox
              [binary]="true"
              [ngModel]="isDeviationSelected(deviation)"
              [disabled]="deviation.StatusId === 9"
              (onChange)="
                onDeviationSelectionChange({
                  checked: $event.checked,
                  data: deviation
                })
              "
            >
            </p-checkbox>
          </td>
          <td class="deviation-cell-number" [attr.data-label]="'NUMBER_NO' | translate" *ngIf="!isPortal">
            <div class="status-and-number">
              <div class="status-icon">
                <i
                  *ngIf="deviation.StatusId == 10"
                  class="{{ deviation.StatusIcon }}"
                  style="color: red"
                ></i>
                <i
                  *ngIf="deviation.StatusId != 10"
                  class="{{ deviation.StatusIcon }}"
                ></i>
              </div>
              <div class="deviation-number">
                <span
                  pTooltip="{{ deviation.No | translate }}"
                  tooltipPosition="top"
                  translate
                  >{{ deviation.No }}</span
                >
              </div>
            </div>
          </td>
          <td class="deviation-cell-number" [attr.data-label]="'NUMBER_NO' | translate" *ngIf="isPortal">
            <div class="status-and-number">
              <div class="status-icon">
                <i
                  *ngIf="deviation.StatusId == 10"
                  class="{{ deviation.StatusIcon }}"
                  style="color: red"
                ></i>
                <i
                  *ngIf="deviation.StatusId != 10"
                  class="{{ deviation.StatusIcon }}"
                ></i>
              </div>
              <div class="deviation-number">
                <span
                  pTooltip="{{ deviation.No | translate }}"
                  tooltipPosition="top"
                  translate
                  >{{ deviation.No }}</span
                >
              </div>
            </div>
          </td>
          <td [attr.data-label]="'BUSINESS' | translate" *ngIf="isAdmin || isPortal">
            <span
              pTooltip="{{ deviation.BusinessName | translate }}"
              tooltipPosition="top"
              translate
              >{{ deviation.BusinessName }}</span
            >
          </td>
          <td class="deviation-cell-title" [attr.data-label]="'TITLE' | translate" *ngIf="isPortal || isAdmin">
            <div class="deviation-title-content">
              <a
                class="truncate-data"
                pTooltip="{{ deviation.Title | translate }}"
                tooltipPosition="top"
                [routerLink]="
                  isPortal
                    ? ['./edit-portal-deviation', deviation['Id']]
                    : ['./edit', deviation['Id']]
                "
                [queryParams]="
                  isPortal
                    ? { Id: deviation.BusinessId, Name: deviation.BusinessName }
                    : {}
                "
              >
                {{ deviation.Title }}</a
              >
              <span
                *ngIf="isQrSource(deviation)"
                class="deviation-qr-source"
                pTooltip="{{ 'DEVIATION_QR_SOURCE' | translate }}"
                tooltipPosition="top"
              ><span class="fa fa-qrcode" aria-hidden="true"></span
              ><span class="sr-only">{{ 'DEVIATION_QR_SOURCE' | translate }}</span></span>
            </div>
          </td>
          <td class="deviation-cell-title" [attr.data-label]="'TITLE' | translate" *ngIf="isEditor">
            <div class="deviation-title-content">
              <a
                class="truncate-data"
                pTooltip="{{ deviation.Title | translate }}"
                tooltipPosition="top"
                [routerLink]="['./edit', deviation['Id']]"
              >
                {{ deviation.Title }}</a
              >
              <span
                *ngIf="isQrSource(deviation)"
                class="deviation-qr-source"
                pTooltip="{{ 'DEVIATION_QR_SOURCE' | translate }}"
                tooltipPosition="top"
              ><span class="fa fa-qrcode" aria-hidden="true"></span
              ><span class="sr-only">{{ 'DEVIATION_QR_SOURCE' | translate }}</span></span>
            </div>
          </td>
          <td class="deviation-cell-title" [attr.data-label]="'TITLE' | translate" *ngIf="!isEditor && !isPortal && !isAdmin">
            <div class="deviation-title-content">
              <a
                *ngIf="
                  deviation.Responsible === true || isShowDeptDeviation === true
                "
                class="truncate-data"
                pTooltip="{{ deviation.Title | translate }}"
                tooltipPosition="top"
                [routerLink]="['./edit', deviation['Id']]"
              >
                {{ deviation.Title }}</a
              >
              <span
                *ngIf="
                  deviation.Responsible !== true && isShowDeptDeviation === false
                "
                pTooltip="{{ deviation.Title }}"
                tooltipPosition="right"
                class="text-overflow"
              >
                {{ deviation.Title }}</span
              >
              <span
                *ngIf="isQrSource(deviation)"
                class="deviation-qr-source"
                pTooltip="{{ 'DEVIATION_QR_SOURCE' | translate }}"
                tooltipPosition="top"
              ><span class="fa fa-qrcode" aria-hidden="true"></span
              ><span class="sr-only">{{ 'DEVIATION_QR_SOURCE' | translate }}</span></span>
            </div>
          </td>
          <td [attr.data-label]="'CHECKLIST_NAME' | translate" *ngIf="isEditor">
            <span
              class="truncate-data"
              pTooltip="{{ deviation.ChecklistName | translate }}"
              tooltipPosition="top"
            >
              {{
                deviation.ChecklistName.length > 28
                  ? (deviation.ChecklistName | slice: 0 : 28) + ".."
                  : deviation.ChecklistName
              }}</span
            >
          </td>
          <td [attr.data-label]="'ACITVITY' | translate" *ngIf="!isAdmin">
            <span
              class="truncate-data"
              pTooltip="{{ deviation.ActivityName | translate }}"
              tooltipPosition="top"
            >
              {{
                deviation.ActivityName?.length > 20
                  ? (deviation.ActivityName | slice: 0 : 20) + ".."
                  : deviation.ActivityName
              }}
            </span>
          </td>
          <td [attr.data-label]="'STATUS' | translate">
            <span translate>{{ deviation.Status }}</span>
          </td>
          <td [attr.data-label]="'IMPORTANCE' | translate">
            <div *ngIf="deviation.Importance.backColor !== ''">
              <span
                class="badge"
                [style.background-color]="deviation.Importance.backColor"
                >{{ deviation.Importance.value | translate }}
              </span>
            </div>
          </td>
          <td [attr.data-label]="'DEPARTMENT' | translate">
            <span
              [pTooltip]="deviation.Department"
              tooltipPosition="top"
              [innerHTML]="deviation.Department"
            ></span>
          </td>
          <td [attr.data-label]="'DEADLINE' | translate">
            <span translate>{{ deviation.DeadlineForPdf }}</span>
          </td>
          <td [attr.data-label]="'MODULES' | translate">
            <span
              pTooltip="{{ deviation.Modules | translate }}"
              tooltipPosition="top"
              translate
              >{{ deviation.Modules | translate }}</span
            >
          </td>
          <td [attr.data-label]="'COST' | translate" *ngIf="showCostColumn">
            <span>{{ deviation.Cost }}</span>
          </td>
          <td [attr.data-label]="'DONE_ON' | translate">
            <span translate>{{
              deviation.CompletedDate | date: "dd/MM/yyyy"
            }}</span>
          </td>
          <td [attr.data-label]="'CREATED_ON' | translate">
            <span translate>{{
              deviation.CreatedOn | date: "dd/MM/yyyy"
            }}</span>
          </td>
          <td class="col-button deviation-cell-actions" *ngIf="hasDeviationDeleteAccess && !isPortal">
            <button
              type="button"
              (click)="confirm(deviation.Id)"
              title="{{ 'DELETE' | translate }}"
              *ngIf="deviation.StatusId !== 9"
            [attr.aria-label]="'DELETE' | translate" class="kuba-icon-btn kuba-icon-btn--danger kuba-icon-btn--row">
            <i class="pi pi-trash"></i>
          </button>
          </td>
        </tr>
      </ng-template>
      <!-- Footer -->
      <ng-template pTemplate="summary">
        <div class="row">
          <div class="col-md-2" *ngIf="!isPortal">
            <div *ngIf="isInternalControl" class="font-weight-bold">
              IC - {{ "INTERNAL_CONTROL" | translate }}
            </div>
            <div *ngIf="isproject" class="font-weight-bold">
              PR - {{ "PROJECT" | translate }}
            </div>
          </div>
          <div class="col-md-2" *ngIf="!isPortal">
            <div *ngIf="isfdv" class="font-weight-bold">
              FDV - {{ "FDV" | translate }}
            </div>
            <div *ngIf="isVehicles" class="font-weight-bold">
              VH - {{ "Vehicle" | translate }}
            </div>
          </div>
          <div class="col-md-2" *ngIf="!isPortal && isIKdeviation">
            <div *ngIf="isFoodSafety" class="font-weight-bold">
              FS - {{ "FOOD_SAFETY" | translate }}
            </div>
            <div *ngIf="isKubaControl" class="font-weight-bold">
              KC - {{ "KUBA_Control" | translate }}
            </div>
          </div>
          <div class="col-md-3" *ngIf="!isPortal && isIKdeviation">
            <div *ngIf="isothersystem" class="font-weight-bold">
              OS - {{ "OTHER_SYSTEMS" | translate }}
            </div>
            <div *ngIf="isqualitysystem" class="font-weight-bold">
              QS - {{ "QUALITY_SYSTEMS" | translate }}
            </div>
          </div>
          <div class="col-md-3" *ngIf="!isPortal && isAHdeviation">
            <div *ngIf="isFramework" class="font-weight-bold">
              RA - {{ "FRAMEWORK_AGREEMENT" | translate }}
            </div>
            <div *ngIf="isService" class="font-weight-bold">
              SA - {{ "SERVICE_AGREEMENT" | translate }}
            </div>
          </div>
          <div class="col-md-3" *ngIf="!isPortal && isAHdeviation">
            <div *ngIf="isKunde" class="font-weight-bold">
              EL - {{ "KUNDE_EL" | translate }}
            </div>
          </div>
        </div>
        <div class="footer-data">
          <div class="symbol-descriptions text-left">
            <div class="symbol-desc-title">
              <span translate>DESCRIPTION_SYMBOLS</span>
            </div>
            <div class="symbol-desc-items">
              <span class="new-deadline">
                <i class="icon ic-md icon-new-deadline"></i>
                <span translate>NEW_ISSUE</span>
              </span>
              <span class="far-deadline">
                <i class="icon ic-md icon-far-deadline"></i>
                <span translate>MORE_DEADLINE</span>
              </span>
              <span class="over-deadline">
                <i class="icon ic-md icon-over-deadline"></i>
                <span translate>OVERDEADLINE</span>
              </span>
              <span class="near-deadline">
                <i class="icon ic-md icon-near-deadline"></i>
                <span translate>LESS_DEADLINE</span>
              </span>
              <span class="clear-deadline">
                <i class="icon ic-md icon-clear-deadline"></i>
                <span translate>DONE_STATUS</span>
              </span>
              <span class="clear-deadline" style="color: red">
                <i class="icon ic-md icon-cancel"></i>
                <span translate>REJECTED</span>
              </span>
            </div>
          </div>
        </div>
      </ng-template>

      <!-- Empty message -->
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td
            [attr.colspan]="
              9 +
              (showCostColumn ? 1 : 0) +
              (isPortal ? 1 : 0) +
              (isAdmin || isPortal ? 1 : 0) +
              (isEditor ? 1 : 0) +
              (!isAdmin ? 1 : 0) +
              (hasDeviationDeleteAccess && !isPortal ? 1 : 0)
            "
          >
            {{ "NO_RECORDS_FOUND" | translate }}
          </td>
        </tr>
      </ng-template>
      <!-- footerColumnGroup -->
      <ng-template pTemplate="groupheader" let-customer>
        <tr pRowGroupHeader>
          <td *ngIf="isPortal"></td>
          <td
            *ngIf="isAdmin"
            [attr.colspan]="(isPortal ? 3 : 5) + (showCostColumn ? 1 : 0)"
            [style]="{ 'text-align': 'right', 'font-weight': 'bold' }"
          >
            {{ "TOTAL_COST" | translate }} :
          </td>
          <td ngIf="isAdmin" [style]="{ 'text-align': 'left' }">
            {{ pageSum }}
          </td>
          <td
            *ngIf="isEditor"
            [attr.colspan]="(isPortal ? 5 : 7) + (showCostColumn ? 1 : 0)"
            [style]="{ 'text-align': 'right', 'font-weight': 'bold' }"
          >
            {{ "TOTAL_COST" | translate }}:
          </td>
          <td *ngIf="isEditor" [style]="{ 'text-align': 'left' }">
            {{ pageSum }}
          </td>
          <td
            *ngIf="!isAdmin && !isPortal && !isEditor"
            [attr.colspan]="showCostColumn ? 6 : 5"
            [style]="{ 'text-align': 'right', 'font-weight': 'bold' }"
          >
            {{ "TOTAL_COST" | translate }} :
          </td>
          <td
            *ngIf="!isAdmin && !isPortal && !isEditor"
            [style]="{ 'text-align': 'left' }"
          >
            {{ pageSum }}
          </td>
          <td
            *ngIf="isPortal"
            [attr.colspan]="showCostColumn ? 5 : 4"
            [style]="{ 'text-align': 'right', 'font-weight': 'bold' }"
          >
            {{ "TOTAL_COST" | translate }} :
          </td>
          <td *ngIf="isPortal" [style]="{ 'text-align': 'left' }">
            {{ pageSum }}
          </td>
          <td *ngIf="isAdmin" [attr.colspan]="isPortal ? 0 : 2"></td>
          <td *ngIf="isEditor" [attr.colspan]="isPortal ? 0 : 1"></td>
          <td *ngIf="!isAdmin && !isPortal && !isEditor" colspan="0"></td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <!-- Dialog for adding type of case -->
  <p-dialog
    header="{{ 'ADD_CASE' | translate }}"
    [(visible)]="addtypeOfCase"
    [style]="{ width: '500px', height: '500px' }"
    [breakpoints]="{ '640px': '92vw' }"
    [resizable]="false"
    [draggable]="false"
    (onHide)="onBeforeDeviationTypeofCaseDialogHide()"
  >
    <form [formGroup]="caseForm">
      <div class="form-group">
        <label for="title" class="col-form-label">
          <span translate>NAME</span>
        </label>
        <div>
          <input
            type="text"
            #Title
            formControlName="Case"
            class="label-input form-control"
          />
          <span style="color: red" *ngIf="isTypeCaseNameExists">{{
            existsTypeCaseAlerttext
          }}</span>
        </div>
      </div>
    </form>
    <ng-template pTemplate="footer">
      <div class="ui-dialog-buttonpane ui-widget-content ui-helper-clearfix">
        <button
          type="button"
          class="btn btn-outline-primary"
          (click)="viewTypeOfCase = !viewTypeOfCase"
        >
          <span translate>VIEW</span>
        </button>
        <button
          type="button"
          class="btn btn-primary"
          [disabled]="!caseForm.valid || loading"
          [ngClass]="{ loading: loading }"
          (click)="saveTypeOfCase()"
        >
          <span *ngIf="!loading" translate>SAVE</span>
          <span *ngIf="loading" translate>SAVE_PROCESS</span>
          <span *ngIf="loading" class="loader-icon"></span>
        </button>
      </div>
      <div *ngIf="viewTypeOfCase">
        <div class="table-view">
          <!-- Table starts -->
          <p-table
            #Type
            [value]="editTypeOfCases"
            [rows]="10"
            [paginator]="true"
            [pageLinks]="3"
            [rowsPerPageOptions]="[5, 10, 20]"
          >
            <!-- Header -->
            <ng-template pTemplate="header">
              <tr>
                <th>{{ "TYPE_NAME" | translate }}</th>
                <th></th>
              </tr>
              <tr>
                <th>
                  <input
                    pInputText
                    type="text"
                    (input)="
                      Type.filter(
                        $any($event.target)?.value,
                        'Name',
                        'contains'
                      )
                    "
                    placeholder=""
                    class="p-column-filter"
                  />
                </th>
                <th></th>
              </tr>
            </ng-template>
            <!-- Body Content -->
            <ng-template pTemplate="body" let-Type>
              <tr>
                <td>
                  <span>{{ Type.Name }}</span>
                </td>
                <td class="col-button">
                  <button
                    type="button"
                    title="{{ 'EDIT' | translate }}"
                    [disabled]="Type.IsDefault"
                    (click)="editTypeOfCase(Type)"
            [attr.aria-label]="'EDIT' | translate" class="kuba-icon-btn kuba-icon-btn--ghost kuba-icon-btn--row">
            <i class="pi pi-pencil"></i>
          </button>
                  <button
                    type="button"
                    title="{{ 'DELETE' | translate }}"
                    [disabled]="Type.IsDefault"
                    (click)="deleteTypeOfCase(Type.Id)"
            [attr.aria-label]="'DELETE' | translate" class="kuba-icon-btn kuba-icon-btn--danger kuba-icon-btn--row">
            <i class="pi pi-trash"></i>
          </button>
                </td>
              </tr>
            </ng-template>
            <!-- Empty message -->
            <ng-template pTemplate="emptymessage" let-columns>
              <tr>
                <td colspan="2">
                  {{ "NO_RECORDS_FOUND" | translate }}
                </td>
              </tr>
            </ng-template>
          </p-table>
          <!-- Table Ends -->
        </div>
      </div>
    </ng-template>
  </p-dialog>

  <!-- Dialog for adding topic -->
  <p-dialog
    header="{{ 'ADD_TOPIC' | translate }}"
    [(visible)]="addTopic"
    [style]="{ width: '500px', height: '500px' }"
    [breakpoints]="{ '640px': '92vw' }"
    [resizable]="false"
    [draggable]="false"
    (onHide)="onBeforeDeviationTopicDialogHide()"
  >
    <form [formGroup]="topicForm">
      <div class="form-group">
        <label for="topic" class="col-form-label">
          <span translate>NAME</span>
        </label>
        <div>
          <input
            type="text"
            #topic
            class="label-input form-control"
            formControlName="Topic"
          />
          <span style="color: red" *ngIf="isTopicNameExists">{{
            existsTopicAlerttext
          }}</span>
        </div>
      </div>
    </form>
    <ng-template pTemplate="footer">
      <div class="ui-dialog-buttonpane ui-widget-content ui-helper-clearfix">
        <button
          type="button"
          class="btn btn-outline-primary"
          (click)="viewTopic = !viewTopic"
        >
          <span translate>VIEW</span>
        </button>
        <button
          type="button"
          class="btn btn-primary"
          [ngClass]="{ loading: loading }"
          [disabled]="!topicForm.valid || loading"
          (click)="saveTopic()"
        >
          <span *ngIf="!loading" translate>SAVE</span>
          <span *ngIf="loading" translate>SAVE_PROCESS</span>
          <span *ngIf="loading" class="loader-icon"></span>
        </button>
      </div>
      <div *ngIf="viewTopic">
        <div class="table-view">
          <!-- Table starts -->
          <p-table
            #Types
            [value]="editTopics"
            [rows]="10"
            [paginator]="true"
            [pageLinks]="3"
            [rowsPerPageOptions]="[5, 10, 20]"
          >
            <!-- Header -->
            <ng-template pTemplate="header">
              <tr>
                <th>{{ "TYPE_NAME" | translate }}</th>
                <th></th>
              </tr>
              <tr>
                <th>
                  <input
                    pInputText
                    type="text"
                    (input)="
                      Types.filter(
                        $any($event.target)?.value,
                        'Name',
                        'contains'
                      )
                    "
                    placeholder=""
                    class="p-column-filter"
                  />
                </th>
                <th></th>
              </tr>
            </ng-template>
            <!-- Body Content -->
            <ng-template pTemplate="body" let-Type>
              <tr>
                <td>
                  <span>{{ Type.Name }}</span>
                </td>
                <td class="col-button">
                  <button
                    type="button"
                    title="{{ 'EDIT' | translate }}"
                    (click)="editTopicType(Type)"
            [attr.aria-label]="'EDIT' | translate" class="kuba-icon-btn kuba-icon-btn--ghost kuba-icon-btn--row">
            <i class="pi pi-pencil"></i>
          </button>
                  <button
                    type="button"
                    title="{{ 'DELETE' | translate }}"
                    (click)="deleteTopic(Type.Id)"
            [attr.aria-label]="'DELETE' | translate" class="kuba-icon-btn kuba-icon-btn--danger kuba-icon-btn--row">
            <i class="pi pi-trash"></i>
          </button>
                </td>
              </tr>
            </ng-template>
            <!-- Empty message -->
            <ng-template pTemplate="emptymessage" let-columns>
              <tr>
                <td colspan="2">
                  {{ "NO_RECORDS_FOUND" | translate }}
                </td>
              </tr>
            </ng-template>
          </p-table>
          <!-- Table Ends -->
        </div>
      </div>
    </ng-template>
  </p-dialog>

  <p-confirmDialog
    header="{{ 'CONFIRMATION' | translate }}"
    icon="pi pi-question-circle"
    width="425"
    acceptLabel="{{ 'SWITCH_YES' | translate }}"
    rejectLabel="{{ 'SWITCH_NO' | translate }}"
  ></p-confirmDialog>
</div>

<!-- Progress Loader for Multi-Delete - moved outside main container -->
<app-progress-loader #progressLoader [config]="progressLoaderConfig">
</app-progress-loader>

<!--Panel Loader-->

<kuba-busy [busy]="Showloader" message="PROCESSING"></kuba-busy>

<!--Panel Loader-->

<!-- QR Code Generator Dialog -->
<app-deviation-qr-generator [(visible)]="showQrGeneratorDialog"></app-deviation-qr-generator>

<!-- Business Selection Dialog for Portal Users -->
<app-business-selection-dialog
  [(visible)]="showBusinessSelectionDialog"
  title="SELECT_BUSINESS"
  description="SELECT_BUSINESS_FOR_NEW_DEVIATION"
  confirmButtonText="NEW_DEVIATION"
  cancelButtonText="CANCEL"
  [required]="true"
  [showClear]="true"
  [filter]="true"
  filterPlaceholder="SEARCH_BUSINESS"
  placeholder="SELECT_BUSINESS"
  (businessSelected)="onBusinessSelected($event)"
  (cancelled)="onBusinessSelectionCancelled()"
  (visibleChange)="onBusinessDialogVisibilityChange($event)"
></app-business-selection-dialog>
